/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_AnalysingInputs */

const en_upload_analysing = /** @type {(inputs: Upload_AnalysingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing documents…`)
};

const pt_br2_upload_analysing = /** @type {(inputs: Upload_AnalysingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processando documentos…`)
};

/**
* | output |
* | --- |
* | "Processing documents…" |
*
* @param {Upload_AnalysingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const upload_analysing = /** @type {((inputs?: Upload_AnalysingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_AnalysingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_analysing(inputs)
	return pt_br2_upload_analysing(inputs)
});